import { LineFormOM } from "./LineForm";


export class FormulaireOM {

  public ListLine: Array<LineFormOM>;

}
